<app-page-header title="Home" active_item="Indicadores" titleLink="/indicators"></app-page-header>

<app-metabase-public-embed
  [url]="
    'https://reports.harpiatechnology.io/public/dashboard/55a1da0e-4dbb-4281-9e38-5dbe5ffa8870
'
  "
>
</app-metabase-public-embed>